import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  HOLIDAY_ADD_ACTION_TYPE,
  HOLIDAY_DELETE_ACTION_TYPE,
  HOLIDAY_DETAIL_ACTION_TYPE,
  HOLIDAY_LIST_ACTION_TYPE,
  headers,
  holidayAddUrl,
  holidayDeleteUrl,
  holidayDetailUrl,
  holidayListUrl,
} from "../../utils/constants";
import moment from "moment";

export const holiday_list_action = (Name, Date, Day,Status) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      Name: Name.toString().trim()?Name:null,
      Date: Date ? moment(Date).format("YYYY-MM-DD") : null,
      Day: Day.toString().trim()?Day:null,
      Status: Status==1?1:Status==0?0:null,
    };
   
    console.log("holiday mapdata...",mapdata, headers);
    const res = await axiosGet(holidayListUrl, mapdata,headers);
    console.log("holiday", res);
    dispatch({
      type: HOLIDAY_LIST_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const holiday_detail_action = (HolidayID) => async (dispatch) => {
  try {
    const params = {
      userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      HolidayID: HolidayID,
    };
    console.log("holiday detail mapdata...", params);
    const res = await axiosGet(holidayDetailUrl, params,headers);
    console.log("detailsHoliday", res);
    dispatch({
      type: HOLIDAY_DETAIL_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const holiday_add_action =
  ( HolidayID, Name, Date, Day,StatusID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        HolidayID: HolidayID ? HolidayID.toString().trim() : "",
        Name: Name.toString().trim(),
        Date: Date ? moment(Date).format("YYYY-MM-DD") : null,
        Day: Day.toString().trim(),
        StatusID: StatusID?StatusID:0,
      };
      console.log("holiday add mapdata...", mapdata);
      const res = await axiosPost(holidayAddUrl, mapdata, headers);
      dispatch({
        type: HOLIDAY_ADD_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const holiday_delete_action =
  ( holidayID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        holidayID: holidayID ? holidayID.toString().trim() : "",
      };

      const res = await axiosGet(holidayDeleteUrl, mapdata,headers);
      dispatch({
        type: HOLIDAY_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
